import '../../App.css';


function TambahCart(e) {
    console.log("Membeli " + e)
  }


  export default TambahCart